import { createAPI } from "../apisServer";

import BaseUrl from "../baseUrls";

const banco = BaseUrl.dataBase;
const apiServer = createAPI("multiTenant");

const reqCentroCusto = {
	listPaginate: async function (param, paramValue, active, page) {
		return apiServer
			.get("portal/v1/centro-custo", {
				params: {
					param,
					paramValue,
					active,
					page,
					perpage: 15,
				},
				headers: {
					banco: banco,
					page,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listID: async function (id) {
		return apiServer
			.get(`portal/v1/centro-custo/${id}`, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	insert: async function (data) {
		return apiServer
			.post("portal/v1/centro-custo", data, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listAll: async function () {
		return apiServer
			.get(`portal/v1/centro-custo/all`, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqCentroCusto;

// listID: async function (id) {
//     return apiServer
//         .get(`v1/categoria/${id}`, {
//             headers: {
//                 banco: banco,
//             },
//         })
//         .then((response) => {
//             return response;
//         })
//         .catch((error) => {
//             throw error;
//         });
// },
// insert: async function (data) {
//     return apiServer
//         .post("v1/categoria", data, {
//             headers: {
//                 banco,
//             },
//         })
//         .then((response) => {
//             return response;
//         })
//         .catch((error) => {
//             throw error;
//         });
// },
// listAll: async function () {
//     return apiServer
//         .get("v1/categoria/all", {
//             headers: {
//                 banco,
//             },
//         })
//         .then((response) => {
//             return response;
//         })
//         .catch((error) => {
//             throw error;
//         });
// },
